import { Component, computed, Signal, signal, ViewChild, WritableSignal } from '@angular/core';
import { PriceListDTO } from 'src/app/models/types/Product/PriceListDTO.type';
import { SharedModule } from 'src/app/modules/shared.module';
import { SharedService } from 'src/app/services/shared.service';
import { ModalComponent } from '../../modal/modal.component';

@Component({
  selector: 'app-price-list-modal',
  imports: [
    ModalComponent,
    SharedModule
  ],
  templateUrl: './price-list-modal.component.html',
  styleUrl: './price-list-modal.component.scss'
})
export class PriceListModalComponent {

  @ViewChild('modal', { static: false }) modal!: ModalComponent;

  private _priceList: WritableSignal<PriceListDTO> = signal([]);
  public priceList: Signal<PriceListDTO> = computed(() => this._priceList());

  constructor(
    public sharedService: SharedService
  ) { }

  openModal(priceList: PriceListDTO) {
    this._priceList.set(priceList);
    this.modal.buildModal();
  }

}
